import { createSlice } from '@reduxjs/toolkit'

export const manageReviewReducer = createSlice({
  name: 'manageReviews',
  initialState: {
    save: false,
    templatesData: [],
    emptyTemplatesData: []
  },
  reducers: {
    setSave: (state, item) => {
      state.save = item.payload
    },
    setTemplatesData: (state, item) => {
      state.templatesData = item.payload
    },
    setEmptyTemplatesData: (state, item) => {
      state.emptyTemplatesData = item.payload
    }
  }
})

export const { setSave, setTemplatesData, setEmptyTemplatesData } = manageReviewReducer.actions
export default manageReviewReducer.reducer